import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AffiliateDisclosurePage from "../pages/affiliate-disclosure/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsOfServicePage from "../pages/terms-of-service/page";

const HomePage = lazy(() => import('../pages/home/page'));
const GiftGuidesPage = lazy(() => import('../pages/gift-guides/page'));
const TechGiftsUnder100Page = lazy(() => import('../pages/gift-guides/tech-under-100/page'));
const LuxuryGiftsPage = lazy(() => import('../pages/gift-guides/luxury-gifts/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const ReviewDetailPage = lazy(() => import('../pages/reviews/[id]/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/gift-guides',
    element: <GiftGuidesPage />,
  },
  {
    path: '/gift-guides/tech-under-100',
    element: <TechGiftsUnder100Page />,
  },
  {
    path: '/gift-guides/luxury-gifts',
    element: <LuxuryGiftsPage />,
  },
  {
    path: '/affiliate-disclosure',
    element: <AffiliateDisclosurePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/reviews/:id',
    element: <ReviewDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
